import styled, { css } from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden/VisuallyHidden';
import { colors, transition } from 'theme/theme';

const markerCss = css`
  border-bottom: 2px solid transparent;

  &:hover {
    border-bottom: 2px solid ${colors.lightContentGrey};
  }
`;

export const TabsItemInput = styled.input`
  ${visuallyHiddenCss}

  &:checked + label {
    color: ${colors.brandBlue};
  }
`;

export const TabsItemLi = styled.li`
  list-style: none;
  user-select: none;
  display: inline-block;
  margin: 0;
  padding: 0;
`;

export const TabsItemLabel = styled.label<{
  $variant: 'background' | 'marker' | 'compact-marker';
}>`
  display: inline-block;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  color: ${colors.lightContentGrey};
  transition: ${transition};

  ${(props) => {
    switch (props.$variant) {
      case 'background':
        return css`
          display: flex;
          align-items: center;
          height: 38px;
          padding-left: 24px;
          padding-right: 24px;
          font-size: 14px;

          &[aria-selected='true'] {
            background: ${colors.softBlue};
            color: ${colors.brandBlue};
          }
        `;
      case 'marker':
        return css`
          ${markerCss};
          height: 47px;
          padding-bottom: 16px;
          padding-left: 16px;
          padding-right: 16px;
        `;
      case 'compact-marker':
        return css`
          ${markerCss};
          padding-bottom: 8px;
        `;
    }
  }}
`;
